import { useState } from 'react';


const useErrorHandling = () => {
    const [errorModalVisible, setErrorModalVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
  
    const showErrorModal = (message) => {
      setErrorMessage(message);
      setErrorModalVisible(true);
    };
  
    const closeErrorModal = () => {
      setErrorModalVisible(false);
    };

  
    return { errorModalVisible, errorMessage, showErrorModal, closeErrorModal };
  };
  
  export default useErrorHandling;